import { useCallback } from 'react';

import {
	type AssistanceServiceInjectedParams,
	type AssistanceServiceInputParam,
	createHookWithAssistanceService,
} from '@atlassian/conversation-assistant-service/services/assistance-service/main';

type UseDeletePromptControllerProps = AssistanceServiceInjectedParams;

export type UseDeletePromptControllerResult = {
	deletePrompt: (shareId: string) => Promise<void>;
};

/**
 * Returns a function to remove the user's access to a prompt via the assistance service DELETE /api/v2/prompts/{shareId} endpoint.
 */
export const useDeletePromptController: (
	props: Omit<AssistanceServiceInjectedParams, 'assistanceServiceInjectedParams'> &
		AssistanceServiceInputParam,
) => UseDeletePromptControllerResult = createHookWithAssistanceService(
	({
		assistanceServiceInjectedParams: { assistanceService },
	}: UseDeletePromptControllerProps): UseDeletePromptControllerResult => {
		const deletePrompt = useCallback(
			(shareId: string) => assistanceService.deletePrompt(shareId),
			[assistanceService],
		);
		return { deletePrompt };
	},
);
